import { useState, useEffect } from 'react';

const useScrollDirection = (threshold = 150, delay = 100) => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollDifference = currentScrollY - lastScrollY;

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Only trigger if we've scrolled more than the threshold
      if (Math.abs(scrollDifference) > threshold) {
        // Scrolling down
        if (scrollDifference > 0) {
          setIsVisible(false);
        }
        // Scrolling up
        else {
          setIsVisible(true);
        }

        // Update the last scroll position
        setLastScrollY(currentScrollY);
      }

      // Set a new timeout to show the header after delay
      const newTimeoutId = setTimeout(() => {
        if (currentScrollY <= 0) {
          setIsVisible(true);
        }
      }, delay);

      setTimeoutId(newTimeoutId);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [lastScrollY, threshold, delay, timeoutId]);

  return !isVisible;
};

export default useScrollDirection;
